export const dynamicDateOptions = [
  { title: 'Inception To Date', value: '1' },
  { title: 'Year To Date', value: '2' },
  {
    title: 'Last 12 Months',
    value: '3'
  },
  {
    title: 'Last 12 Months Less One Month  ',
    value: '4'
  },
  {
    title: 'Last 24 Months',
    value: '5'
  },
  {
    title: 'Last 36 Months',
    value: '6'
  }
];

export const dateMatchTypeOptions = [
  {
    title: 'All Dates ',
    value: '1'
  },
  {
    title: 'Common Start Date ',
    value: '2'
  },
  {
    title: 'Intersection',
    value: '3'
  }
];

export const customDateMatchTypeOptions = [
  {
    title: 'Quarter Selection ',
    value: '1'
  },
  {
    title: 'Month Selection ',
    value: '2'
  },
  {
    title: 'Day Selection ',
    value: '3'
  }
];
